import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import plugin from './plugins'
import 'element-ui/lib/theme-chalk/index.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import watermark from './utils/watermark'
Vue.prototype.$watermark = watermark
import PortalVue from 'portal-vue'
Vue.use(Viewer)
Vue.use(PortalVue)
Vue.use(plugin)
Vue.config.productionTip = false
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
